import React, {useState} from 'react'
import { InputRadio } from '../../radio/InputRadio';

export function ConditionNodeCondition({form, errors, loading, setForm, setErrors}) {

    const [condTypes] = useState([
        { key: "EQ", text: "Равно", value: "EQ" },
        { key: "NE", text: "Не равно", value: "NE" },
        { key: "GT", text: "Больше", value: "GT" },
        { key: "LT", text: "Меньше", value: "LT" },
    ]);

    const [conditions] = useState([
        { key: "COURSE", text: "Курс", value: "COURSE" },
        { key: "COURSE_TYPE", text: "Тип курса", value: "COURSE_TYPE" },
        { key: "WEEK", text: "Неделя курса", value: "WEEK" },
        { key: "DAY", text: "День курса", value: "DAY" },
        { key: "NOT_ACTIVE", text: "Клиент не активен", value: "NOT_ACTIVE" },
        { key: "WAKING_TIME", text: "Время пробуждения в будни и выходные", value: "WAKING_TIME" },
        { key: "INSTALLMENT", text: "Рассрочка", value: "INSTALLMENT" },
        { key: "RESPONSE_ILLNESS_SEND", text: "Отправить сообщения по болезням", value: "RESPONSE_ILLNESS_SEND" },
        { key: "DISEASE_SET", text: "Список болезней заполнен", value: "DISEASE_SET" },
        { key: "DISEASE", text: "Болезнь равна", value: "DISEASE" },
    ]);

    const [courses] = useState([
        {key: 'NotActive', text: 'Не активен', value: 'NotActive'},
        {key: 'Active', text: 'Любой активный курс', value: 'Active'},
        {key: 'PsychWeek', text: 'Психологическая неделя', value: 'PsychWeek'},
        {key: 'Detox', text: 'Детокс', value: 'Detox'},
        {key: 'Express', text: 'Экспресс', value: 'Express'},
        {key: 'Marathon', text: 'Марафон', value: 'Marathon'},
        {key: 'Balance', text: 'Баланс', value: 'Balance'}
    ]);

    const [courseTypes] = useState([
        {key: '1', text: 'Полная оплата', value: '1'},
        {key: '2', text: 'Рассрочка', value: '2'},
        {key: '3', text: 'Недельный', value: '3'},
    ]);

    const [installments] = useState([
        {key: '[part1]', text: '[part1]', value: '[part1]'},
        {key: '[part2]', text: '[part2]', value: '[part2]'},
        {key: '[part3]', text: '[part3]', value: '[part3]'}
    ]);

    const [diseases] = useState([
        'сахарный диабет', 'гастрит', 'язва (в ремиссии)', 'панкреатит', 'дуоденит', 'гипертония', 'холецистит',
        'гипотиреоз', 'джвп (дискинезия желчевыводящих путей)', 'удаление щитовидной железы', 'нефролитиаз',
        'пиелонефрит', 'мочекаменная болезнь (мкб)', 'желчнокаменная болезнь', 'грудное кормление', 'инсулинорезистентность',
        'гепатоз', 'язвенный колит', 'холецистэктомия', 'нефроптоз'
    ]);

    const [allowedCondTypes] = useState({
        COURSE: ["EQ", "NE"],
        COURSE_TYPE: ["EQ", "NE"],
        WAKING_TIME: ["EQ", "NE"],
        INSTALLMENT: ["EQ"],
        RESPONSE_ILLNESS_SEND: ["EQ", "NE"],
        DISEASE_SET: ["EQ", "NE"],
        DISEASE: ["EQ"]
    });

    const handleAddCondition = () => {
        setForm({...form, conditions: [...(form.conditions || []), {cond: '', cond_type: 'EQ', value: ''}]});
    }

    const handleRemoveCondition = (index) => {
        setForm({...form, conditions: (form.conditions || []).filter((_, i) => i !== index)});
    }

    const handleChangeCondition = (index, name, value) => {
      setForm({
        ...form,
        conditions: (form.conditions || []).map((cond, i) =>
            i === index ? {...cond, [name]: value} : cond
        )
      });
    }

    const handleChangeRadio = (name, value) => {
        setForm({...form, [name]: value});
    }


    return <>
        <div className="profile__wrap" style={{maxWidth: '300px'}}>
            <div className="profile__group" style={{display: 'flex', gap: '10px'}}>
                <InputRadio text="И" name="operator" value={'AND'} checked={form.operator === 'AND'} onChange={() => handleChangeRadio('operator', 'AND')}/>
            </div>
            <div className="profile__group" style={{display: 'flex', gap: '10px'}}>
                <InputRadio text="ИЛИ" name="operator" value={'OR'} checked={form.operator === 'OR'} onChange={() => handleChangeRadio('operator', 'OR')}/>
            </div>
        </div>

        <div className="profile__wrap">
            {(form.conditions || []).length === 0 && <div>
                <button type="button" className="btn" onClick={handleAddCondition}> Добавить условие</button>
            </div>}
            <div>
                {(form.conditions || []).map((cond, index) => (
                    <div className="condition__item" key={index}>
                        <select
                            className={`dropdown__select select`}
                            name="cond"
                            value={cond.cond}
                            onChange={(e) => handleChangeCondition(index, 'cond', e.target.value)}
                        >
                            <option value="">выберите</option>
                            {conditions.map(option => (<option key={option.value} value={option.value}>{option.text}</option>))}
                        </select>
                        <select
                            className={`dropdown__select select`}
                            name="cond_type"
                            value={cond.cond_type}
                            onChange={(e) => handleChangeCondition(index, 'cond_type', e.target.value)}
                        >
                            {condTypes.filter(e => !allowedCondTypes.hasOwnProperty(cond.cond) || allowedCondTypes[cond.cond].includes(e.value))
                                        .map(option => (<option key={option.value} value={option.value}>{option.text}</option>))}
                        </select>

                        {cond.cond === 'NOT_ACTIVE' && <><input type="text" className="profile__input input" value={cond.value || ''}
                                                                onChange={(e) => handleChangeCondition(index, 'value', e.target.value)}   name="value" /> <span style={{fontSize: '12px', marginTop: '5px'}}> дней</span></>}

                        {cond.cond === 'COURSE' && <><select
                            className={`dropdown__select select`}
                            name="value"
                            value={cond.value}
                            onChange={(e) => handleChangeCondition(index, 'value', e.target.value)}>
                            {courses.map(option => (<option key={option.value} value={option.value}>{option.text}</option>))}
                        </select></>}

                        {cond.cond === 'COURSE_TYPE' && <><select
                            className={`dropdown__select select`}
                            name="value"
                            value={cond.value}
                            onChange={(e) => handleChangeCondition(index, 'value', e.target.value)}>
                            {courseTypes.map(option => (<option key={option.value} value={option.value}>{option.text}</option>))}
                        </select></>}

                        {cond.cond === 'WEEK' && <><select
                            className={`dropdown__select select`}
                            name="value"
                            value={cond.value}
                            onChange={(e) => handleChangeCondition(index, 'value', e.target.value)}>
                            {[1,2,3,4].map(week => (
                                <option key={week} value={week}>{week} неделя</option>
                            ))}
                        </select></>}

                        {cond.cond === 'DAY' && <><select
                            className={`dropdown__select select`}
                            name="value"
                            value={cond.value}
                            onChange={(e) => handleChangeCondition(index, 'value', e.target.value)}>
                            {Array.from({length: 28}, (_, i) => i + 1).map(i => (
                                <option key={i} value={i}>{i} день</option>
                            ))}
                        </select></>}

                        {cond.cond === 'INSTALLMENT' && <><select
                            className={`dropdown__select select`}
                            name="value"
                            value={cond.value}
                            onChange={(e) => handleChangeCondition(index, 'value', e.target.value)}>
                            {installments.map(option => (<option key={option.value} value={option.value}>{option.text}</option>))}
                        </select></>}

                        {cond.cond === 'DISEASE' && <><select
                            className={`dropdown__select select`}
                            name="value"
                            value={cond.value}
                            onChange={(e) => handleChangeCondition(index, 'value', e.target.value)}>
                            {diseases.map(option => (<option key={option} value={option}>{option}</option>))}
                        </select></>}

                        <button type="button" className="btn small-btn" onClick={() => handleAddCondition(index)}> + </button>
                        <button type="button" className="btn small-btn red" onClick={() => handleRemoveCondition(index)}> - </button>
                    </div>
                ))}
            </div>

        </div>
    </>;
}